'use strict';

/**
 * @name MapOptions
 * @type {Object}
 * @property {string}       type
 * @property {String}       gmap_selector      マップ要素のセレクタ
 * @property {Object}       gmap_options_default GoogleMapに渡すオプション（デフォルト）
 * @property {Object}       gmap_options       GoogleMapに渡すオプション
 * @property {String}       container_selector     マップを囲う要素のセレクタ
 * @property {String[]}     outer_frame_selectors  マップサイズ調整用、マップ外の要素のセレクタ
 */

/**
 * GoogleMapで表示する
 * 
 * @name GoogleMap
 * @extends {Map}
 */
export default class GoogleMap{
  /**
   * @param {EventEmitter} mapEvents
   * @param {PopupFactory} popupFactory
   * @param {PlaceType} placeType
   * @param {MapOptions} options
   */
  constructor(mapEvents, popupFactory, placeType, options) {
    this.mapEvents = mapEvents;
    this.popupFactory = popupFactory;
    this.placeType = placeType;
    this.options = options;
    this.gevent = google.maps.event;
    this.gmarkers = {};
  }
  /**
   * マップを作成
   * 
   * @access private
   * @returns {google.maps.Map}
   */
  createMap() {
    var map_canvas = $(this.options.gmap_selector);
    var opt = $.extend(this.options.gmap_options_default, this.options.gmap_options);
    return new google.maps.Map(map_canvas[0], opt);
  }
  /**
   * 初期化
   * 
   * @access public
   */
  reset() {

    // TODO
    this.ginfo_window = new google.maps.InfoWindow({
      maxWidth: 300
    });

    // FIXME: API sampleでは scroll:auto になっているが、何故かつかないので無理矢理変更
    // scrollしないと高さの低いブラウザで閲覧した時に、ポップアップの吹き出し表示が崩れる
    this.gevent.addListener(this.ginfo_window, 'domready', function() {
      $(this.content).parent().css({
        'overflow-y': 'auto',
        'min-height': '70px'
      });
    });

  }
  /**
   * ih.start()で呼ばれる
   * 
   * @access public
   */
  start() {
    this.gmap = this.createMap();
  }
  /**
   * マップサイズの調整
   * resizeイベント割当はcoreが行う
   * 
   * @access public
   * @returns {void}
   */
  adjustMapSize(){
    var minus = _.reduce(this.options.outer_frame_selectors, function(val, frame){
      return val + $(frame).height() + 0;
    }, 0);

    var height = window.innerHeight - minus; // iPhone safari: height()だとアドレスバーの部分が引かれた値になる
    var width = $(window).width();

    var container = $(this.options.container_selector);
    container.height(height);
    var map_canvas = $(this.options.gmap_selector);
    map_canvas.width(width);
    map_canvas.height(height);
  }
  /**
   * マップ中心位置、基準位置を変更する
   * 
   * @access public
   * @param {google.maps.LatLng} latlng
   */
  setCenterAndCurrentLocation(latlng) {
    // fit_boundsを使う場合、中心位置に移動は意味をなさない
    this.gmap.setCenter(latlng);
    this.updateCurrentLocation(latlng);
  }
  /**
   * 検索の基準位置を変更する
   *
   * @access public
   * @param {google.maps.LatLng} latlng
   * @returns {google.maps.LatLng}
   */
  updateCurrentLocation(latlng) {
    if (!latlng) {
      var c = this.gmap.getCenter();
      latlng = this.createLatLng(c.lat(), c.lng());
    }
    this.displayBaseMarker(latlng);

    this.current_search_location = latlng;
    return this.current_search_location;
  }
  /**
   * 検索時の基準位置を取得する
   *
   * @access public
   * @returns {google.maps.LatLng}
   */
  getCurrentSearchLocation(){
    return this.current_search_location;
  }
  /**
   * 検索範囲を指定した場合に用いる、円を表示
   *
   * @access public
   * @param r
   */
  displayCircle(r) {
    /**
     * マップの中心に赤い円を表示する
     */
    if (radius == "all") {
      return 0;
    }
    
    var cc = this.center_circle;
    var latlng = this.getCurrentSearchLocation();
    var radius = parseFloat(r) * 1000;

    if (cc != "") {
      if (this.center_circle) {
        this.center_circle.setMap(null);
      }
      this.center_circle = "";
    }

    this.center_circle = new google.maps.Circle({
      center: latlng, // 中心点(google.maps.LatLng)
      fillColor: '#ff0000', // 塗りつぶし色
      fillOpacity: 0.03, // 塗りつぶし透過度（0: 透明 ⇔ 1:不透明）
      map: this.gmap, // 表示させる地図（google.maps.Map）
      radius: radius, // 半径（ｍ）
      strokeColor: '#ff0000', // 外周色 
      strokeOpacity: 1, // 外周透過度（0: 透明 ⇔ 1:不透明）
      strokeWeight: 1         // 外周太さ（ピクセル）
    });
  }
  /**
   * マーカーを全消去
   *
   * @access public
   */
  clearMarkersAll() {
    /**
     * 表示されているすべてのマーカーを非表示
     */
    this.ginfo_window.close();

    // gmarkersは連想配列
    if (this.gmarkers.places){
      $.each(this.gmarkers.places, function(k) {
        this.setMap(null);
      });
    }

    this.gmarkers.places = {};
  }
  /**
   * google.maps.Markerを生成し、地図上に配置する。
   * オーバーライド許可するが、markerを内部管理する必要があるのでcreateMarker以外からは呼ばないように
   *
   * @access private
   * @param {type} jm
   * @returns {google.maps.Marker}
   */
  _createMarkerObject(jm){
    var latlng = this.createLatLng(jm.lat, jm.lng);
    return new google.maps.Marker({
      map: this.gmap,
      position: latlng,
      zIndex: 1000,
//      optimized: false,
      icon: this.placeType.getMarkerIcon(jm.type)
    });
  }
  /**
   * 現在表示中のマーカーを取得
   *
   * @access public
   * @returns {Array.<google.maps.Marker>}
   */
  getDisplayMarkers(){
    return this.gmarkers['places'];
  }
  /**
   * 施設マーカーを取得
   *
   * @access public
   * @param id
   * @returns {google.maps.Marker}
   */
  getPlaceMarker(id){
    if (!this.gmarkers['places']) {
      this.gmarkers['places'] = {};
    }
    return this.gmarkers['places'][id];
  }
  /**
   * 施設オブジェクトから、地図上にマーカーをプロットする
   *
   * @access protected
   * @param {Place} jm
   * @returns {google.maps.Marker}
   */
  createMarker(jm) {
    if (!jm) return;

    if (!this.gmarkers['places']) {
      this.gmarkers['places'] = {};
    }

    if (this.gmarkers['places'][jm.id]){
      // すでに生成されているので作る必要なし
      return this.gmarkers['places'][jm.id];
    }
    /*
     * マーカー生成
     */
    var marker = this._createMarkerObject(jm)

    this.gmarkers['places'][jm.id] = marker;

    return marker;
  }
  /**
   * マーカーのポップアップを生成し、イベントリスナーに登録する
   *
   * @access protected
   * @param {Place} place
   * @param {google.maps.Marker} marker
   * @return {DOMElement}
   */
  createMarkerPopup(place, marker){
    // ポップアップのDOM/HTML
    var popup = this.popupFactory.build(place);
    
    if (!popup) {
      return;
    }
    /**
     * マーカーにイベントリスナー登録
     */
    this.gevent.addListener(marker, 'click', () => {
      // コア側にイベントを渡す（その後、ポップアップを開くかどうかはコアに任せる）
      this.mapEvents.emit('ihClickMarker', place, marker, popup);
    });
    
    return popup;
  }
  /**
   * マーカーポップアップを開く
   * 
   * @access public
   * @param marker
   * @param popup
   */
  toggleMarkerPopup(marker, popup){
    var that = this;
    // toggleする
    if (that.isOpenMarkerPopup(popup)){
      that.closeMarkerPopup();
    }else{
      that.setMarkerPopup(popup);

      var f = this.ginfo_window;
      var panorama = that.gmap.getStreetView();
      if (panorama.getVisible()){
        f.open(panorama, marker);
      }else{
        f.open(that.gmap, marker);
      }
    }
  }

  /**
   * 指定のマーカーポップアップが開いているか？
   * 
   * @param popup
   * @returns {boolean}
   */
  isOpenMarkerPopup(popup){
    var f = this.ginfo_window;
    return f.getContent() === popup;
  }
  /**
   * マーカーポップアップを閉じる
   * 
   */
  closeMarkerPopup(){
    var f = this.ginfo_window;
    f.close();
    f.setContent(""); // closeしても要素は残る
  }
  /**
   * 
   * @param popup
   */
  setMarkerPopup(popup){
    var f = this.ginfo_window;
    f.setContent(popup);
  }
  /**
   * マーカーを地図上にプロットする
   *
   * @access public
   * @param {Request} request
   * @param {Array} places
   */
  displayMarkers(request, places) {

    for (var i = 0, len = places.length; i < len; i++) {
      var place = places[i];
      if (!place) continue;
      
      // マーカーを生成して表示
      var marker = this.createMarker(place);
      
      // ポップアップを生成してリスナーに登録
      var popup = this.createMarkerPopup(place, marker);
    }

  }

  /**
   * 基準位置マーカーを表示
   * 
   * @param {google.maps.LatLng} latlng
   */
  displayBaseMarker(latlng) {
    var that = this;

    // すでに配置済みのBaseMarkerを除去
    if (this.gmarkers['center']) {
      this.gmarkers['center'].setMap(null);
    }
    this.gmarkers['center'] = null;

    // マーカーを真ん中に表示
    var marker = new google.maps.Marker({
      map: this.gmap,
      position: latlng,
      draggable: true, // draggableの場合zIndexにかかわらず最前面になる？？
      zIndex: 100
//      animation: google.maps.Animation.DROP
    });
    this.gmarkers['center'] = marker;

    // ドラッグ
    this.gevent.addListener(marker, 'dragstart', function() {
      marker.setAnimation(google.maps.Animation.BOUNCE);
    });
    this.gevent.addListener(marker, 'drag', function() {
      marker.setAnimation(google.maps.Animation.BOUNCE);
    });
    this.gevent.addListener(marker, 'dragend', function() {
      marker.setAnimation(null);
      that.updateCurrentLocation(marker.position);

      var latlng = marker.position;
      that.reSearch({lat: latlng.lat(), lng: latlng.lng()}).then(function(res){
        $(that).trigger('ihUpdateCenterMarker', res);
      });

    });
  }
  /**
   * 
   * @param lat
   * @param lng
   * @returns {google.maps.LatLng}
   */
  createLatLng(lat, lng) {
    return new google.maps.LatLng(lat, lng);
  }

  /**
   * 中心位置オブジェクトを取得
   *
   * @access public
   * @returns {google.maps.LatLng}
   */
  getCenter() {
    return this.gmap.getCenter();
  }
  /**
   *
   * @access public
   * @params {google.maps.LatLng} latlng
   */
  setCenter(latlng) {
    this.gmap.setCenter(latlng);
  }
  /**
   * 指定された座標に地図を移動させる
   *
   * @access public
   * @param {number} lat
   * @param {number} lng
   * @param {boolean?} circle
   * @return {boolean} 戻り値
   */
  moveMap(lat, lng, circle) {
    var latlng = this.createLatLng(lat, lng);
    this.gmap.setCenter(latlng);
    if (circle){
      this.displayCircle(this.getRadius());
      this.displayBaseMarker(latlng);
    }
  }
  /**
   * 指定施設に移動して、マーカークリック動作を起動
   * 
   * @access public
   * @param place
   */
  moveAndFocus(place){
    if (place.lat && place.lng){
      this.map.moveMap(place.lat, place.lng, false);
    }
    this.map.focusMarker(place.id);
  }
  /**
   * マーカーがクリックされた際の処理
   * 
   * @access public
   */
  focusMarker(markerNum) {
    if (markerNum && markerNum != "none") {
      this.gevent.trigger(this.gmarkers.places[markerNum], 'click');
    }
  }
  /**
   * 仕方なく外からgooglemapを操作したい時
   * 
   * @access public
   * @returns {google.maps.Map}
   */
  getMap() {
    return this.gmap;
  }
  /**
   * 指定の施設が全て表示されるようにズームと位置調整する
   * 
   * @param {Array} places
   */
  fitBounds(places) {
    var bounds = new google.maps.LatLngBounds();
    _.each(places, (place) => {
      if (place.lat && place.lng){
        bounds.extend(this.createLatLng(place.lat, place.lng));
      }
    });
    if (places.length > 0){
      bounds.extend(this.getCurrentSearchLocation());
      // 基準位置１つだけになると最も大きく拡大されてしまうので初期位置も追加
      // => しかしおすすめコースの場合に思ったように拡大されないので無効化
      // bounds.extend(that.getInitLocation());
      this.gmap.fitBounds(bounds);
    }
  }
}




// WEBPACK FOOTER //
// ./map/js/ih/map/GoogleMap.js